import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { FormikProps } from 'formik';
import { SUBMOTIVE3, SUBMOTIVE3_DETAIL } from '../../../../../routes/paths';
import {
    asyncGetParamWithNestedParent,
    asyncGetSubmotive3Historical,
    asyncPatchSubmotive3Param,
    asyncPostSubmotive3Param,
} from '../../../../../services/param.service';
import { ToastSwal } from '../../../../components/general/toastSwals/toastSwal';
import { Param, ParamHistorical } from '../../../../../shared/types/param';

export const useSubmotive3Form = () => {
    const navigate = useNavigate();
    const { idSubmotive3 } = useParams();
    const [submotive3, setSubmotive3] = useState<Param>();
    const [loading, setLoading] = useState(false);
    const [formikSubmotive3Data, setFormikSubmotive3Data] =
        useState<FormikProps<Param>>();
    const [showHistorical, setShowHistorical] = useState(false);
    const [submotive3Historical, setSuptypeDPHistorical] =
        useState<ParamHistorical[]>();

    const isValidForm = formikSubmotive3Data?.isValid;

    const handleCleanAndBack = () => {
        formikSubmotive3Data?.resetForm();
        navigate(SUBMOTIVE3);
    };

    const handleSubmit = async () => {
        await formikSubmotive3Data?.submitForm();

        if (!isValidForm) return;

        setLoading(true);

        const data: Param = formikSubmotive3Data?.values;

        let res: any | undefined = undefined;

        try {
            if (submotive3 && submotive3.id)
                res = await asyncPatchSubmotive3Param(submotive3.id, data);
            else res = await asyncPostSubmotive3Param(data);
        } catch (error) {}
        if (res?.items) {
            const item = Array.isArray(res?.items) ? res?.items[0] : res?.items;
            ToastSwal.fire({
                text: `¡Felicidades! el submotivo 3 se ${
                    submotive3 && submotive3.id ? 'actualizo' : 'creó'
                } satisfactoriamente.`,
                icon: 'success',
                timer: 5000,
                position: 'center-end',
            });
            navigate(`${SUBMOTIVE3_DETAIL}/${item.id}`);
        } else {
            ToastSwal.fire({
                text: `Lo sentimos, no se pudo ${
                    submotive3 && submotive3.id ? 'actualizar' : 'crear'
                } el submotivo 3. Por favor, asegúrate de ${
                    submotive3 && submotive3.id
                        ? 'diligenciar los datos correctamente'
                        : 'que no exista previamente'
                } e intenta nuevamente más tarde.`,
                icon: 'error',
                timer: 5000,
                position: 'center-end',
            });
        }

        setLoading(false);
    };

    useEffect(() => {
        if (Boolean(idSubmotive3)) {
            setLoading(true);
            asyncGetParamWithNestedParent(idSubmotive3, 4)
                .then((submotive3: any) => {
                    if (!submotive3 || !submotive3.items) navigate(SUBMOTIVE3);
                    setSubmotive3(submotive3?.items);
                })
                .finally(() => setLoading(false));
        }
    }, [idSubmotive3]);

    useEffect(() => {
        if (showHistorical) {
            setLoading(true);
            asyncGetSubmotive3Historical(idSubmotive3)
                .then((resp) => {
                    if (resp) setSuptypeDPHistorical(resp);
                })
                .finally(() => setLoading(false));
        }
    }, [showHistorical]);

    return {
        submotive3,
        loading,
        isValidForm,
        handleSubmit,
        handleCleanAndBack,
        setFormikSubmotive3Data,
        submotive3Historical,
        showHistorical,
        setShowHistorical,
    };
};
